const STORAGE_KEY = 'tfp:pdp-adjacent:v1';
const MAX_AGE_MS = 30 * 60 * 1000;

function productHandle(input) {
  try {
    const url = new URL(input, window.location.href);
    if (url.origin !== window.location.origin) return null;
    return url.pathname.match(/\/products\/([^/]+)\/?$/)?.[1] ?? null;
  } catch {
    return null;
  }
}

function readContext() {
  try {
    const context = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || 'null');
    if (
      context?.version !== 1 ||
      !Array.isArray(context.items) ||
      context.items.length < 2 ||
      !Number.isFinite(context.createdAt) ||
      context.createdAt > Date.now() ||
      Date.now() - context.createdAt > MAX_AGE_MS
    ) return null;
    return context;
  } catch {
    return null;
  }
}

function captureCollectionClick(event) {
  if (
    !(event.target instanceof Element) ||
    event.button !== 0 ||
    event.metaKey ||
    event.ctrlKey ||
    event.shiftKey ||
    event.altKey
  ) return;

  const card = event.target.closest('product-card');
  const list = card?.closest('collection-component > results-list');
  if (!list || card.hasAttribute('data-no-navigation')) return;
  const currentLink = card.querySelector('a.product-card__link[href]');
  const currentHandle = currentLink && productHandle(currentLink.href);
  if (!currentHandle) return;

  const interactive = event.target.closest('button, input, label, select, textarea, a');
  if (interactive) {
    if (!(interactive instanceof HTMLAnchorElement)) return;
    if (productHandle(interactive.href) !== currentHandle) return;
  }

  const seen = new Set();
  const items = [];
  for (const candidate of list.querySelectorAll('product-card')) {
    const link = candidate.querySelector('a.product-card__link[href]');
    const handle = link && productHandle(link.href);
    if (!handle || seen.has(handle)) continue;
    seen.add(handle);
    items.push({
      handle,
      url: link.href,
      title: link.getAttribute('aria-label') || '',
    });
  }

  if (items.length < 2 || !seen.has(currentHandle)) return;
  try {
    sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ version: 1, createdAt: Date.now(), source: window.location.href, items })
    );
  } catch {}
}

function mountProductNavigation() {
  const nav = document.querySelector('[data-tfp-pdp-adjacent]:not([data-adjacent-mounted])');
  if (!(nav instanceof HTMLElement)) return;

  const context = readContext();
  const currentHandle = productHandle(nav.dataset.productUrl || window.location.href);
  const index = context?.items.findIndex((item) => item.handle === currentHandle) ?? -1;
  if (index < 0) return;

  const previous = context.items[index - 1];
  const next = context.items[index + 1];
  if (!previous && !next) return;

  nav.setAttribute('data-adjacent-mounted', '');

  for (const [selector, item] of [
    ['[data-adjacent-previous]', previous],
    ['[data-adjacent-next]', next],
  ]) {
    const anchor = nav.querySelector(selector);
    if (!(anchor instanceof HTMLAnchorElement) || !item || !productHandle(item.url)) continue;
    anchor.href = item.url;
    const title = anchor.querySelector('[data-adjacent-title]');
    if (title) title.textContent = item.title;
    anchor.hidden = false;
  }

  const position = nav.querySelector('[data-adjacent-position]');
  if (position) {
    position.textContent = (nav.dataset.positionTemplate || '__current__ / __total__')
      .replace('__current__', String(index + 1))
      .replace('__total__', String(context.items.length));
  }

  nav.hidden = false;
}

function initialize() {
  if (document.querySelector('collection-component > results-list') && !document.documentElement.hasAttribute('data-tfp-adjacent-capture')) {
    document.documentElement.setAttribute('data-tfp-adjacent-capture', '');
    document.addEventListener('click', captureCollectionClick, true);
  }
  mountProductNavigation();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initialize, { once: true });
} else {
  initialize();
}
document.addEventListener('shopify:section:load', initialize);
document.addEventListener('product-runtime:refresh', mountProductNavigation);
